import { render, staticRenderFns } from "./Factures.vue?vue&type=template&id=4737b0b0&scoped=true&"
import script from "./Factures.vue?vue&type=script&lang=js&"
export * from "./Factures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4737b0b0",
  null
  
)

export default component.exports